import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  RejectPendingOperationResponse,
  rejectPendingOperationResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'
import { throwOnAccessDenied } from 'api/throwOnAccessDenied'

export const useAPIRejectPendingOperation = (
  nonce: string,
  options?: UseMutationOptions<RejectPendingOperationResponse, ErrorResponse>
) =>
  useMutation({
    mutationFn: () =>
      post(
        API_ENDPOINTS.REJECT_PENDING_OPERATION.replace(':nonce', nonce),
        {},
        rejectPendingOperationResponseSchema
      ),
    ...options,
    throwOnError: throwOnAccessDenied,
  })
